import { render } from "./ConfigAgentDialog.vue?vue&type=template&id=a2bfb8e2"
import script from "./ConfigAgentDialog.vue?vue&type=script&lang=js"
export * from "./ConfigAgentDialog.vue?vue&type=script&lang=js"

import "./ConfigAgentDialog.vue?vue&type=style&index=0&id=a2bfb8e2&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__